const DEFAULT_SITE_KEY = '6LfPe-AUAAAAAOhE13kr75_XxA11o0xP8YYbMf8q';

export const SITE_KEY = process.env.RECAPTCHA_SITE_KEY_V3 || DEFAULT_SITE_KEY;

export const SIGN_OUT_TYPES = {
	USER_ACTION: 'USER_ACTION',
	SESSION_ENDED: 'SESSION_ENDED'
};

export const REGISTRATION_TYPES = {
	MOJEID: 'MOJEID',
	COMMFIDES: 'COMMFIDES',
	FULL_REGISTRATION: 'FULL_REGISTRATION',
	XSELL: 'XSELL',
	BANKID_ONE_BUTTON: 'ONE_BUTTON',
	BANKID_SWISH: 'SWISH',
	BANKID_RETRIEVE_BALANCE: 'RETRIEVE_BALANCE',
	TRUSTLY: 'TRUSTLY',
	MITID: 'MITID',
	NEMID: 'NEMID',
	TRANSACTION_LINK: 'TRANSACTION_LINK'
} as const;

export const LOGIN_TYPES = {
	USERNAME_PASSWORD: 'USERNAME_PASSWORD',
	BACKDOOR: 'BACKDOOR_USERNAME_PASSWORD',
	REOPEN: 'REOPEN'
};
